<template>
  <v-col
    v-if="resource"
    id="resources"
    cols="12"
    sm="10"
    md="8"
    style="max-width: 1100px"
  >
    <v-skeleton-loader
      v-if="loading"
      ref="skeleton"
      :boilerplate="false"
      :type="'list-item, article, list-item-three-line'"
      class="mx-auto"
      width="100vw"
      max-width="600"
    />

    <template v-else>
      <div class="headline mb-6">
        {{ resource.name }}
        <v-divider class="pb-3" />
      </div>

      <div class="body-2">
        {{ resource.description }}
      </div>

      <Section
        v-if="resource"
        :resource="resource"
      />
    </template>

    <!--<Downloadable
      v-if="resource"
    />-->
  </v-col>
</template>

<script>
import resourceApi from '@/api/coach-profile/resource';
import Section from './widget/Section.vue';
// import Downloadable from './widget/Downloadable.vue';

export default {
  name: 'Resources',

  components: {
    Section,
    // Downloadable,
  },

  data: () => ({
    loading: false,
    resource: null,

    // TODO remove
    resources: {
      video: [],
      download: [],
    },
  }),

  computed: {
    resourceId() {
      return String(this.$route.params.type);
    },
  },

  watch: {
    resourceId(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.getResource();
      }
    },
  },

  async mounted() {
    this.getResource();
    // this.downloadFiles();
  },

  methods: {
    async getResource() {
      try {
        this.loading = true;
        const response = await resourceApi.getResource();
        if (response && response.length) {
          this.resource = response
            .find((item) => String(item.id) === String(this.$route.params.type));
        }
      } catch (err) {
        console.log('Resource get', err);
        this.$toast.error(err.msg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
